// =============================================================================
// PORTAL FORGOT PASSWORD PAGE (PortalForgotPasswordPage.js)
// =============================================================================
// Lets users request a password reset code via email.
// Adapted from cdic-portal-react/client/src/pages/ForgotPasswordPage.js
// =============================================================================

import React, { useState } from 'react';
import { forgotPassword } from './portalApi';
import PortalLayout from './PortalLayout';
import PortalFlashMessage from './PortalFlashMessage';

function PortalForgotPasswordPage({ onNavigate }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('info');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const data = await forgotPassword(email);
      setMessage(data.message);
      setMessageType('success');

      setTimeout(() => {
        onNavigate('reset-password', { email });
      }, 2000);
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PortalLayout showLogout={false} onNavigate={onNavigate}>
      <div className="cdic-portal-form-box">
        <h2>Forgot Password</h2>
        <p style={{ color: '#666', marginBottom: '20px', fontSize: '14px', lineHeight: 1.5 }}>
          Enter your email address and we'll send you instructions to reset your password.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="cdic-portal-input-container">
            <i className="material-icons">email</i>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? 'SENDING...' : 'SEND INSTRUCTIONS'}
            {!isLoading && <i className="material-icons" style={{ marginLeft: '5px' }}>send</i>}
          </button>
        </form>

        <PortalFlashMessage
          message={message}
          type={messageType}
          onClose={() => setMessage('')}
        />

        <a
          href="#login"
          onClick={(e) => { e.preventDefault(); onNavigate('login'); }}
          style={{ marginTop: '15px', display: 'inline-block' }}
        >
          <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>
            arrow_back
          </i>
          {' '}Back to Login
        </a>
      </div>
    </PortalLayout>
  );
}

export default PortalForgotPasswordPage;
